import RecycleRIGHT from './RecycleRIGHT';

export default RecycleRIGHT;
